import { startCase, snakeCase } from 'lodash';

export function camelCaseFormat(value) {
  if (!value) {
    return '';
  }
  value = value.toString();
  return startCase(snakeCase(value));
}
